import { Container as Wrapper } from "@bootstrap-styled/v4"
import { useLocation } from "react-router-dom"
import { BetaTag } from "components/shared/BetaTag/BetaTag"
import styled from "styled-components"
import { constants } from "utils"
import { useFeatureFlag } from "hooks/useFeatureFlag"
import { initialTab } from "../sessionReportTabs"

// "Session Insights By Session" / "By Lesson", read from the same URL tab the
// side nav highlights. The page writes its resolved tab into the URL, so the
// three agree once the lesson probe settles.
export const SessionHeader = () => {
  const { search } = useLocation()
  const lessonReportsEnabled = useFeatureFlag("lessonReport")
  const view =
    lessonReportsEnabled && initialTab(search) === "lessons"
      ? constants.BY_LESSON
      : constants.BY_SESSION
  return (
    <Container>
      {constants.SESSION_HISTORY} {view} <BetaTag />
    </Container>
  )
}

const Container = styled(Wrapper)`
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  gap: .5rem;
  align-items: center;
`
